import { compact, flatten, has, isEmpty, map } from 'lodash';
export default function getInitialFilters(options) {
  return flatten(compact(map(options, o => {
    if (has(o, 'children') && !isEmpty(o.children)) {
      return compact(map(o.children, opt => opt.initial ? opt.value : null));
    }
    return o.initial ? o.value : null;
  })));
}
//# sourceMappingURL=getInitialFilters.js.map